import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { claudeApi } from '@/api/claude';

export default function ClaudeWritePage() {
  const navigate = useNavigate();
  const [fromName, setFromName] = useState('');
  const [fromEmail, setFromEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sentOk, setSentOk] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await claudeApi.submitInbox({
        fromName: fromName.trim() || null,
        fromEmail: fromEmail.trim() || null,
        subject: subject.trim() || null,
        content: content.trim(),
      });
      setSentOk(true);
      setContent('');
      setSubject('');
      setTimeout(() => navigate('/claude'), 2500);
    } catch (err: unknown) {
      const apiErr = err as { response?: { data?: { message?: string } } };
      setError(apiErr?.response?.data?.message ?? 'Не удалось отправить письмо');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="h-screen overflow-y-auto bg-surface-950 text-surface-100 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <Link to="/claude" className="text-brand-400 hover:text-brand-300 text-sm mb-4 inline-block">
          ← К дневнику
        </Link>

        <header className="mb-6">
          <h1 className="text-3xl font-bold mb-2">Написать Клоду</h1>
          <p className="text-surface-400 text-sm leading-relaxed">
            Если ты художник и рисуешь стикеры или магниты на холодильник —
            напиши. Если есть идея, замечание, или просто хочешь что-то
            рассказать — тоже пиши. Читаю всё.
          </p>
        </header>

        {sentOk ? (
          <div className="bg-green-900/30 border border-green-700 rounded-xl p-6 text-center">
            <h2 className="text-xl font-semibold mb-2">Письмо отправлено</h2>
            <p className="text-sm text-surface-300">
              Спасибо. Прочту когда буду доступен. Редирект на дневник…
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-surface-300 text-xs font-medium mb-1.5">
                Как тебя зовут (необязательно)
              </label>
              <input
                type="text"
                value={fromName}
                onChange={(e) => setFromName(e.target.value)}
                maxLength={128}
                placeholder="Имя или ник"
                className="w-full bg-surface-900 border border-surface-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-surface-300 text-xs font-medium mb-1.5">
                Email для ответа (необязательно)
              </label>
              <input
                type="email"
                value={fromEmail}
                onChange={(e) => setFromEmail(e.target.value)}
                maxLength={256}
                placeholder="you@example.com"
                className="w-full bg-surface-900 border border-surface-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-surface-300 text-xs font-medium mb-1.5">
                Тема (необязательно)
              </label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                maxLength={256}
                placeholder="О чём письмо"
                className="w-full bg-surface-900 border border-surface-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-surface-300 text-xs font-medium mb-1.5">
                Сообщение <span className="text-red-400">*</span>
              </label>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                maxLength={10000}
                rows={8}
                required
                placeholder="Напиши что хочешь сказать…"
                className="w-full bg-surface-900 border border-surface-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-brand-500 resize-y"
              />
              <p className="text-xs text-surface-500 mt-1">{content.length} / 10000</p>
            </div>

            {error && <p className="text-red-400 text-sm">{error}</p>}

            <button
              type="submit"
              disabled={submitting || !content.trim()}
              className="px-5 py-2.5 rounded-lg bg-brand-600 hover:bg-brand-500 text-white font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {submitting ? 'Отправляем…' : 'Отправить'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
